import { useEffect, useState } from "react";
import { DragDropContext, Draggable } from "react-beautiful-dnd";
import { RiDragDropFill, RiFileListLine } from "react-icons/ri";
import { BsArrowLeftCircleFill } from "react-icons/bs";
import { AiFillInfoCircle } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { StrictModeDroppable } from "../../../helpers/strictModeDragDropHelper";
const SelectedAttributePanel = (props) => {
  const [demoAttribute, setDemoAttribute] = useState([]);
  const { localization } = useLanguageContext();

  useEffect(() => {
    setDemoAttribute(props.selectedAttribute);
  }, [props.selectedAttribute]);

  /* ....................handle Delete Attribute....................... */

  function handleDeleteAttribute(deletingAttribute, attributeIndex) {
    props.handleDeleteAttribute(deletingAttribute, attributeIndex);
  }

  /* ....................handle CheckBox Updation....................... */

  function handleCheckBox(event, name) {
    const checkBox = event.target.value;
    demoAttribute.forEach((element, index) => {
      if (element.name === name) {
        element[checkBox] = event.target.checked ? true : false;
      }
    });
    props.updateSelectedAttribute(demoAttribute);
  }

  /* ....................handle Drag and Drop inside Div....................... */
  const handleDrop = (droppedItem) => {
    // Ignore drop outside droppable container
    if (!droppedItem.destination) return;
    var updatedList = [...demoAttribute];
    // Remove dragged item
    const [reorderedItem] = updatedList.splice(droppedItem.source.index, 1);
    // Add dropped item
    updatedList.splice(droppedItem.destination.index, 0, reorderedItem);
    // Update State
    setDemoAttribute(updatedList);
    props.updateSelectedAttribute(updatedList);
  };

  return (
    <>
      {demoAttribute?.length > 0 ? (
        <div className="container" id="rightPanel">
          <div className="row">
            <h2 className="col">
              {localization.youCanswitchtheAttribute}
              <RiDragDropFill id="dragDropFillTest" className="svgIcon" />
            </h2>
          </div>
          <div className="row my-custom-scrollbar p-1">
            <DragDropContext onDragEnd={handleDrop}>
              <StrictModeDroppable droppableId="container">
                {(provided) => (
                  <div
                    className="col"
                    {...provided.droppableProps}
                    ref={provided.innerRef}
                  >
                    <ul className="row d-flex flex-column ul-style pl-0">
                      {demoAttribute.map((standardAttr, index) => (
                        <li className="col" key={index}>
                          <Draggable
                            key={standardAttr.attributeID.toString()}
                            draggableId={standardAttr.attributeID.toString()}
                            index={index}
                          >
                            {(provided) => (
                              <div
                                className="row"
                                ref={provided.innerRef}
                                {...provided.dragHandleProps}
                                {...provided.draggableProps}
                              >
                                <div className="col-10">
                                  <div className="row flex-column">
                                    <div className="col ">
                                      <p>{standardAttr.nameDisplay}</p>
                                    </div>
                                    <div className="col">
                                      <div className="row rpcheckbox ">
                                        <div className="col-4">
                                          <div className="form-check form-check-inline">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`onAddFormularCheckbox${index}`}
                                              defaultChecked={
                                                standardAttr.onAddFormular
                                              }
                                              value="onAddFormular"
                                              onChange={(event) => {
                                                handleCheckBox(
                                                  event,
                                                  standardAttr.name,
                                                );
                                              }}
                                            ></input>
                                            <label
                                              className="form-check-label standardAttrChkLabel"
                                              htmlFor={`onAddFormularCheckbox${index}`}
                                            >
                                              {localization.onAddFormCheckBox}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-4">
                                          <div className="form-check form-check-inline ">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`isEditableCheckbox${index}`}
                                              defaultChecked={
                                                standardAttr.isEditable
                                              }
                                              value="isEditable"
                                              onChange={(event) => {
                                                handleCheckBox(
                                                  event,
                                                  standardAttr.name,
                                                );
                                              }}
                                            ></input>
                                            <label
                                              className="form-check-label standardAttrChkLabel"
                                              htmlFor={`isEditableCheckbox${index}`}
                                            >
                                              {localization.isEditableCheckBox}
                                            </label>
                                          </div>
                                        </div>
                                        <div className="col-3">
                                          <div className="form-check form-check-inline ">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`isMandatoryCheckbox${index}`}
                                              defaultChecked={
                                                standardAttr.isMandatory
                                              }
                                              value="isMandatory"
                                              onChange={(event) => {
                                                handleCheckBox(
                                                  event,
                                                  standardAttr.name,
                                                );
                                              }}
                                            ></input>
                                            <label
                                              className="form-check-label standardAttrChkLabel"
                                              htmlFor={`isMandatoryCheckbox${index}`}
                                            >
                                              {localization.isMandatoryCheckbox}
                                            </label>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {standardAttr.isReadOnly ? (
                                  <div className="col-1 align-self-center">
                                    <AiFillInfoCircle
                                      id="attributeMandatoryTest"
                                      className="cursorPoint svgIcon"
                                      title={
                                        localization.thisAttributeisMandatory
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div className="col-1 align-self-center">
                                    {standardAttr.pos ? (
                                      <MdDelete
                                        id="deleteAttributeTest"
                                        className="mr-4 cursorPoint svgIcon"
                                        size={20}
                                        title={localization.deleteAttribute}
                                        onClick={() => {
                                          handleDeleteAttribute(
                                            standardAttr,
                                            index,
                                          );
                                        }}
                                      />
                                    ) : (
                                      <BsArrowLeftCircleFill
                                        className="mr-4 cursorPoint svgIcon"
                                        id="moveAttributeLeftTest"
                                        size={20}
                                        title={localization.moveAttributeLeft}
                                        onClick={() => {
                                          handleDeleteAttribute(
                                            standardAttr,
                                            index,
                                          );
                                        }}
                                      />
                                    )}
                                  </div>
                                )}
                                {standardAttr.hasOptions ? (
                                  <div className="col-1 align-self-center">
                                    <RiFileListLine
                                      className="mr-4 cursorPoint svgIcon"
                                      id="optionsListTest"
                                      size={20}
                                      title={localization.clickToSeeOptions}
                                      data-toggle="modal"
                                      data-target="#optionsListPopUp"
                                      onClick={() => {
                                        props.handleOptionsListPopUpCallback(
                                          standardAttr,
                                        );
                                      }}
                                    ></RiFileListLine>
                                  </div>
                                ) : (
                                  <></>
                                )}
                              </div>
                            )}
                          </Draggable>
                        </li>
                      ))}
                    </ul>
                    {provided.placeholder}
                  </div>
                )}
              </StrictModeDroppable>
            </DragDropContext>
          </div>
        </div>
      ) : (
        <div className="my-custom-panel-position">
          {localization.selectAttribute}
        </div>
      )}
    </>
  );
};

export default SelectedAttributePanel;
